import React from 'react';
import { Card, CardContent, Grid, TextField, CardActions, Button, CardHeader, FormControlLabel, Checkbox,
		 MenuItem } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { withSnackbar } from 'notistack';
import { Editor } from 'react-draft-wysiwyg';
import Dropzone from '../../components/Dropzone';
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import Empty from 'validator/lib/isEmpty';

//CSS
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './lojas.css';

//services
import LojaAPI from '../../../services/api/Loja';
import SegmentoAPI from '../../../services/api/Segmento';

import { MaskTelefoneDefault } from '../../../utils/mask';


class NovaLoja extends React.Component {
	state = {
		loading:false,

		nome: '',
		piso: '',
		loja: '',
		descricao: EditorState.createEmpty(),
		arquivo:'',
		telefone: '',
		email: '',
		site: '',
		fotos:[],
		instagram:'',
		facebook:'',
		destaque: false,
		servico: false,
		isAtiva: true,
		segmento_id: 0,

		data_arquivo:null,

		segmentos: [],

		isNome:false,
		isPiso:false,
		isLoja:false,
		isArquivo:false,
		isDescricao:false,
		isSegmento: false,
	}

	Submit = (event) => {
		const { enqueueSnackbar, history } = this.props;
		const { nome, piso, loja, descricao, arquivo, telefone, email, site,
				fotos, instagram, facebook, destaque, segmento_id, servico, isAtiva } = this.state;
		event.preventDefault();
		this.setState({ isNome: false, isPiso: false, isArquivo: false, isDescricao: false, isSegmento: false });
		if (Empty(nome)) {
			this.setState({ isNome: true }, () => enqueueSnackbar('Preencha o campo de nome'));
			return;
		}
		if (Empty(piso)) {
			this.setState({ isPiso: true }, () => enqueueSnackbar('Preencha o campo de piso'));
			return;
		}
		if (Empty(loja)) {
			this.setState({ isPiso: true }, () => enqueueSnackbar('Preencha o campo de loja'));
			return;
		}
		if (arquivo === '') {
			this.setState({ isArquivo: true }, () => enqueueSnackbar('Selecione uma imagem'));
			return;
		}
		if (descricao === '') {
			this.setState({ isDescricao: true }, () => enqueueSnackbar('Preencha o campo de descrição'));
			return;
		}
		if (segmento_id === 0) {
			this.setState({ isSegmento: true }, () => enqueueSnackbar('Selecione um segmento'));
			return;
		}

		this.setState({ loading:true }, () => enqueueSnackbar("Aguarde efetuando o cadastro.."));
		let forms = {
			nome: nome,
			descricao: draftToHtml(convertToRaw(descricao.getCurrentContent())),
			piso: piso,
			loja: loja,
			telefone: telefone,
			email: email,
			site: site,
			instagram: instagram,
			facebook: facebook,
			destaque: destaque,
			servico: servico,
			segmento_id: segmento_id,
			fotos,
			arquivo,
			ativa: isAtiva,
		}

		LojaAPI.cadastro(forms)
				.then(res => {
					res.json().then(res => {
						if (res.msg) {
							this.setState({ loading: false }, () => enqueueSnackbar(res.msg));
							return;
						}
						enqueueSnackbar('Cadastro efetuado com sucesso');
						history.push('/painel/lojas');
					})
				}).catch(() => this.setState({ loading: false }, () => enqueueSnackbar('Não foi possivel efetuar o cadastro, tente novamente mais tarde.')))

		return;
	}

	refreshSegmentos = () => {
		const { enqueueSnackbar } = this.props;
		SegmentoAPI.lista()
				.then(res => {
					res.json().then(res => {
						if (res.msg) {
							this.setState({ loading: false }, () => enqueueSnackbar(res.msg));
							return;
						}
						this.setState({ segmentos: res })
						return;
					})
				}).catch(() => this.setState({ loading: false }, () => enqueueSnackbar('Não foi possivel carregar a lista')))
	}

	componentDidMount(){
		this.refreshSegmentos();
	}

    render() {
		const { data_arquivo, descricao, loading, telefone, email, site, nome, fotos,
				piso, loja, instagram, facebook, destaque, segmento_id, segmentos,
				isSegmento, isNome, isLoja, isPiso, isArquivo, servico, isAtiva } = this.state;
        return (
				<div className="app_control__content_padding" >
					<Grid container spacing={16} >
						<Grid item xs={12} >
							<form onSubmit={this.Submit} >
								<Card elevation={0} >
									<CardHeader title="Cadastro" />
									<CardContent>
										<Grid container spacing={16} >
											<Grid item xs={3} >
												<FormControlLabel
													control={
													<Checkbox checked={isAtiva} onChange={(e) => this.setState({ isAtiva: e.target.checked})} />
													}
													label="Ativa"
												/>
											</Grid>
											<Grid item xs={3} >
												<FormControlLabel
													control={
													<Checkbox checked={destaque} onChange={(e) => this.setState({ destaque: e.target.checked})} />
													}
													label="Destaque"
												/>
											</Grid>
											<Grid item xs={3} >
												<FormControlLabel
													control={
													<Checkbox checked={servico} onChange={(e) => this.setState({ servico: e.target.checked})} />
													}
													label="Serviço destaque"
												/>
											</Grid>
											<Grid item xs={12} >
												<TextField
													label="Nome"
													value={nome}
													onChange={e => this.setState({ nome: e.target.value })}
													margin="normal"
													variant="outlined"
													error={isNome}
													fullWidth
												/>
											</Grid>
											<Grid item xs={4} >
												<TextField
													label="Piso"
													type="number"
													value={piso}
													placeholder="Ex: 1"
													onChange={e => this.setState({ piso: e.target.value })}
													margin="normal"
													variant="outlined"
													error={isPiso}
													fullWidth
												/>
											</Grid>
											<Grid item xs={4} >
												<TextField
													label="Loja"
													placeholder="Ex: 2"
													type="number"
													value={loja}
													onChange={e => this.setState({ loja: e.target.value })}
													margin="normal"
													variant="outlined"
													error={isLoja}
													fullWidth
												/>
											</Grid>
											<Grid item xs={4} >
												<TextField
													select
													label="Segmento"
													value={segmento_id}
													onChange={(e) => this.setState({ segmento_id: e.target.value })}
													margin="normal"
													variant="outlined"
													error={isSegmento}
													fullWidth
												>
													<MenuItem value={0}>
														-- Selecione um segmento --
													</MenuItem>
													{segmentos.map(seg => (
														<MenuItem key={seg.id} value={seg.id}>
															{seg.nome}
														</MenuItem>
													))}
												</TextField>
											</Grid>
											<Grid item xs={12} >
												<TextField
													label="Logo"
													type="file"
													onChange={e => this.setState({ arquivo: e.target.files[0],
																				   data_arquivo: URL.createObjectURL(e.target.files[0]) })}
													margin="normal"
													variant="outlined"
													fullWidth
													error={isArquivo}
													InputLabelProps={{
														shrink:true
													}}
												/>
											</Grid>
											{data_arquivo && <Grid item xs={12} >
												<img width="30%" style={{marginBottom:-8}} src={data_arquivo} alt="Demo" />
											</Grid>}
											<Grid item xs={4} >
												<TextField
													label="Email"
													placeholder="Ex: contato@loja.com.br"
													value={email}
													onChange={e => this.setState({ email: e.target.value })}
													margin="normal"
													variant="outlined"
													fullWidth
												/>
											</Grid>
											<Grid item xs={4} >
												<TextField
													label="Telefone"
													placeholder="Ex: (27) 3333-4444"
													value={telefone}
													onChange={e => this.setState({ telefone: e.target.value })}
													margin="normal"
													InputProps={{
														inputComponent: MaskTelefoneDefault,
													}}
													variant="outlined"
													fullWidth
												/>
											</Grid>
											<Grid item xs={4} >
												<TextField
													label="Site"
													placeholder="Ex: www.loja.com.br"
													value={site}
													onChange={e => this.setState({ site: e.target.value })}
													margin="normal"
													variant="outlined"
													fullWidth
												/>
											</Grid>
											<Grid item xs={3} >
												<TextField
													label="Facebook"
													placeholder="Ex: Loja"
													value={facebook}
													onChange={e => this.setState({ facebook: e.target.value })}
													margin="normal"
													variant="outlined"
													fullWidth
												/>
											</Grid>
											<Grid item xs={3} >
												<TextField
													label="Instagram"
													placeholder="Ex: Loja"
													value={instagram}
													onChange={e => this.setState({ instagram: e.target.value })}
													margin="normal"
													variant="outlined"
													fullWidth
												/>
											</Grid>
											<Grid item xs={12} >
												<Editor editorState={descricao}
														toolbarClassName="toolbarEditor"
														wrapperClassName="wrapperEditor"
														editorClassName="editorBodyEditor"
														toolbar={{options: ['inline', 'fontSize'],}}
														onEditorStateChange={(s) => this.setState({ descricao: s })} />
											</Grid>
											<Grid item xs={12} >
												<Dropzone title="Clique ou arraste fotos nesta caixa" files={fotos} onUpdateFiles={arquivos => this.setState({ fotos: arquivos })} />
											</Grid>
										</Grid>
									</CardContent>
									<CardActions>
										<Button type="submit" variant="outlined" disabled={loading} color="primary" >Cadastrar</Button>
										<Button variant="outlined" color="inherit" component={Link} to="../lojas" >cancelar</Button>
									</CardActions>
								</Card>
							</form>
						</Grid>
					</Grid>
				</div>
        );
    }
}

export default withSnackbar(NovaLoja);



// WEBPACK FOOTER //
// ./src/painel/pages/lojas/nova.js